import {FormSetup} from "../models/definitions/FormSetup";
import {QuestionSetup} from "../models/definitions/QuestionSetup";
import {DynamicFormsSetupEditorData} from "./DynamicFormsSetupEditorData";

export function nullableOf(value: any) {
	const isNotPresent = value === undefined
		|| value === null
		|| value === "";
	// || (Array.isArray(value) && value.length === 0)
	// || (typeof value === "object" && Object.keys(value).length === 0);
	
	return {
		isPresent: !isNotPresent,
		value: isNotPresent ? null : value
	};
}

export function getValue<TObject extends FormSetup | QuestionSetup, TValue>(
	field: keyof TObject & string,
	data: DynamicFormsSetupEditorData<TObject>,
	isWrapped: boolean,
	fallback?: TValue,
	debug = false
): TValue {
	if (debug)
		console.log(`reading field ${field}`);
	if (isWrapped) {
		if (debug)
			console.log("reading wrapped value");
		return getNullableValue(field, data, debug) ?? fallback ?? null;
	} else {
		if (debug)
			console.log("reading direct value");
		return getDirectValue(field, data, debug) ?? fallback ?? null;
	}
}

export function getNullableValue<TObject extends FormSetup | QuestionSetup>(
	field: keyof TObject,
	data: DynamicFormsSetupEditorData<TObject>,
	debug: boolean
): any | null {
	const wrapped = getDirectValue(field, data, debug);
	return wrapped?.value ?? null;
}

export function getDirectValue<TObject extends FormSetup | QuestionSetup>(
	field: keyof TObject,
	data: DynamicFormsSetupEditorData<TObject>,
	debug: boolean
): any | null {
	const value: any = data.setup[field];
	if (value !== null && value !== undefined) {
		if (debug)
			console.log("found value");
		return value;
	}
	if (data.parentData !== null) {
		if (debug)
			console.log("asking value from parent");
		return getDirectValue(field, data.parentData, debug);
	}
	
	if (debug)
		console.log("could not find value");
	return null;
}

export function getDefaultValue<TObject extends FormSetup | QuestionSetup, TValue>(
	field: keyof TObject,
	data: DynamicFormsSetupEditorData<TObject>,
	isWrapped: boolean,
	fallback?: TValue
): TValue | undefined {
	if (isWrapped)
		return getNullableDefaultValue(field, data) ?? fallback ?? null;
	return getDirectDefaultValue(field, data) ?? fallback ?? null;
}

export function getNullableDefaultValue<TObject extends FormSetup | QuestionSetup>(
	field: keyof TObject,
	data: DynamicFormsSetupEditorData<TObject>
): any | null {
	const wrapped = getDirectDefaultValue(field, data);
	return nullableOf(wrapped?.value);
}

export function getDirectDefaultValue<TObject extends FormSetup | QuestionSetup>(
	field: keyof TObject,
	data: DynamicFormsSetupEditorData<TObject>
): any | null {
	return data.originalSetup[field];
}
